<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { Writable } from 'svelte/store';

    import { trans } from '$assets/translator.js';
    import Button from '$saga/components/Button.svelte';
    import Modal from '$saga/components/Modal.svelte';

    export let isOpen: Writable<boolean>;

    const dispatch = createEventDispatcher<{
        confirm: void;
        cancel: void;
    }>();

    let confirmButton: HTMLButtonElement | null = null;

    const closeModal = () => {
        $isOpen = false;
        dispatch('cancel');
    };

    const confirmDelete = () => {
        dispatch('confirm');
        $isOpen = false;
    };

    // Focus the confirm button when modal opens
    $: if ($isOpen && confirmButton) {
        confirmButton.focus();
    }
</script>

<Modal {isOpen} onClose={closeModal} fullScreen={false}>
    <div class="shadow-lg w-full max-w-2xl bg-white px-5xl py-4xl">
        <h2 class="text-center text-2xl font-semibold text-blue-brand">
            {trans('form.multi_image_upload.delete_image')}
        </h2>
        <p class="pt-2xl text-center">
            {trans('form.multi_image_upload.delete_confirm')}
        </p>
        <div class="flex justify-center gap-4 pt-2xl">
            <Button
                type="button"
                intent="tertiary"
                size="small"
                on:click={closeModal}
            >
                {trans('action.cancel')}
            </Button>
            <button
                type="button"
                class="vp-button vp-button--primary vp-button--rounded vp-button--small"
                on:click={confirmDelete}
                bind:this={confirmButton}
            >
                {trans('action.confirm')}
            </button>
        </div>
    </div>
</Modal>
